import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { KnBrQuoteReferenceEffects } from './kn-br-quote-reference.effects';
import { knBrQuoteReferenceReducer } from './kn-br-quote-reference.reducer';
import { KN_BR_QUOTE_REFERENCE_FEATURE } from './kn-br-quote-reference.state';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(KN_BR_QUOTE_REFERENCE_FEATURE, knBrQuoteReferenceReducer),
    EffectsModule.forFeature([KnBrQuoteReferenceEffects]),
  ],
})
export class KnBrQuoteReferenceStateModule {}
